import { Injectable } from '@angular/core';
import { IStorageItem } from './storage-item.interface';

@Injectable()
export class StorageService {
  public get(key: string): object | null {
    const itemString: any = localStorage.getItem(key);
    let item: IStorageItem;

    try {
      item = JSON.parse(itemString) as IStorageItem;

      if (item) {
        if (item.hasOwnProperty('ttl') && item.ttl !== undefined) {
          if (item.ttl >= Date.now()) {
            return item.value;
          }
        } else {
          return item.value;
        }
      }
    } catch (err) {
      console.log(err);
    }

    return null;
  }

  public set(item: IStorageItem) {
    const storedValue: any = { value: item.value };

    if (item.ttl !== undefined) {
      storedValue.ttl = Date.now() + item.ttl * 1000;
    }

    return localStorage.setItem(item.key, JSON.stringify(storedValue));
  }

  public remove(item: IStorageItem) {
    return localStorage.removeItem(item.key);
  }

  public clear() {
    return localStorage.clear();
  }
}
